// AUTH TYPES
export const AUTH_LOGIN_USER = "AUTH_LOGIN_USER";
export const AUTH_LOGIN_USER_FAIL = "AUTH_LOGIN_USER_FAIL";
export const AUTH_LOGIN_USER_SUCCESS = "AUTH_LOGIN_USER_SUCCESS";
export const AUTH_CREATE_USER = "AUTH_CREATE_USER";
export const AUTH_CREATE_USER_FAIL = "AUTH_CREATE_USER_FAIL";
export const AUTH_CREATE_USER_SUCCESS = "AUTH_CREATE_USER_SUCCESS";
export const AUTH_LOGOUT_USER = "AUTH_LOGOUT_USER";

// PROFILE TYPES FETCH
export const FETCH_PROFILE_INFO = "FETCH_PROFILE_INFO";
export const FETCH_PROFILE_INFO_SUCCESS = "FETCH_PROFILE_INFO_SUCCESS";
export const FETCH_PROFILE_INFO_FAILED = "FETCH_PROFILE_INFO_FAILED";

// FRIENDS TYPES FETCH
export const FETCH_FRIENDS_INFO = "FETCH_FRIENDS_INFO";
export const FETCH_FRIENDS_INFO_SUCCESS = "FETCH_FRIENDS_INFO_SUCCESS";
export const FETCH_FRIENDS_INFO_FAILED = "FETCH_FRIENDS_INFO_FAILED";

// ADD FRIEND TYPES
export const ADD_FRIEND = "ADD_FRIEND";
export const ADD_FRIEND_FETCH = "ADD_FRIEND_FETCH";
export const DELETE_ADD_FRIEND_FETCH = "DELETE_ADD_FRIEND_FETCH";
export const DELETE_ADD_FRIEND = "DELETE_ADD_FRIEND";
export const REFUSE_ADD_FRIEND_FETCH = "REFUSE_ADD_FRIEND_FETCH";
export const REFUSE_ADD_FRIEND = "REFUSE_ADD_FRIEND";
export const ACCEPT_ADD_FRIEND = "ACCEPT_ADD_FRIEND";
export const DELETE_FRIEND = "DELETE_FRIEND";
export const ACCEPT_ADD_FRIEND_FETCH = "ACCEPT_ADD_FRIEND_FETCH";
export const DELETE_FRIEND_FETCH = "DELETE_FRIEND_FETCH";

// USERNAMES TYPES FETCH
export const FETCH_USERNAMES_INFO = "FETCH_USERNAMES_INFO";
export const FETCH_USERNAMES_INFO_SUCCESS = "FETCH_USERNAMES_INFO_SUCCESS";
export const FETCH_USERNAMES_INFO_FAILED = "FETCH_USERNAMES_INFO_FAILED";

// EXPANSION TYPES FETCH
export const FETCH_EXPANSION_FETCH = "FETCH_EXPANSION_FETCH";
export const FETCH_EXPANSION_FETCH_SUCCESS = "FETCH_EXPANSION_FETCH_SUCCESS";
export const FETCH_EXPANSION_FETCH_ERROR = "FETCH_EXPANSION_FETCH_ERROR";
export const FETCH_EXPANSION_INFO = "FETCH_EXPANSION_INFO";
export const FETCH_EXPANSION_INFO_SUCCESS = "FETCH_EXPANSION_INFO_SUCCESS";
export const FETCH_EXPANSION_INFO_ERROR = "FETCH_EXPANSION_INFO_ERROR";

// ADD EXPANSION TYPES
export const ADD_EXPANSION = "ADD_EXPANSION";
export const ADD_EXPANSION_FETCH = "ADD_EXPANSION_FETCH";
export const ADD_EXPANSION_FETCH_ERROR = "ADD_EXPANSION_FETCH_ERROR";

// GAME TYPES FETCH
export const FETCH_GAME_INFO = "FETCH_GAME_INFO";
export const FETCH_GAME_INFO_SUCCESS = "FETCH_GAME_INFO_SUCCESS";
export const FETCH_GAME_INFO_FAILED = "FETCH_GAME_INFO_FAILED";

// GAME TYPES CREATE
export const CREATE_GAME = "CREATE_GAME";
export const CREATE_GAME_SUCCESS = "CREATE_GAME_SUCCESS";
export const CREATE_GAME_FAILED = "CREATE_GAME_FAILED";

// GAME TYPES LEAVE
export const LEAVE_GAME = "LEAVE_GAME";
export const LEAVE_GAME_SUCCESS = "LEAVE_GAME_SUCCESS";
export const LEAVE_GAME_FAILED = "LEAVE_GAME_FAILED";

// GAME TYPES ENTER
export const ENTER_GAME = "ENTER_GAME";
export const ENTER_GAME_SUCCESS = "ENTER_GAME_SUCCESS";
export const ENTER_GAME_FAILED = "ENTER_GAME_FAILED";

// RESET STATES
export const RESET = "RESET";
